<!--If you do not know how WellnessTaskTemplate corresponds to WellnessTask, then please get clarification
prior to changing this page. -->

<br>
<form id="taskForm" #taskForm="ngForm">
  <div class="p-grid">
    <div class="p-col-6 columnPadding">
      <div class="p-grid">
        <div class="p-col-6">
          <h4>Wellness Task Template Information</h4>
        </div>
      </div>
      <br>
      <div class="p-grid">
        <div class="p-col-12">
          <h6>Task Name</h6>
          @if (task) {
          <input pInputText fluid name="name" [(ngModel)]="task.name" required />
          }
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-6">
          <h6>Price</h6>
          @if (task) {
          <p-inputgroup>
            <p-inputgroup-addon>$</p-inputgroup-addon>
            <p-inputnumber name="price" [(ngModel)]="task.price" (ngModelChange)="currencyInputChanged($event)" />
          </p-inputgroup>
          }
        </div>
        <div class="p-col-6">
          <h6>Growing Degree Day</h6>
          @if (task) {
          <input pInputText fluid type="number" min="0" oninput="validity.valid||(value='');" name="gdd"
            [(ngModel)]="task.growingDegreeDay" />
          }
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-2" style="margin-top: 30px;font-weight: 500;">
          @if (task) {
            <label for="active">Active &nbsp; </label> 
            <p-checkbox binary="true" name="active" [(ngModel)]="task.active"></p-checkbox>
            }
        </div>
      </div>
    </div>
    <div class="p-col-6 columnPadding topMargin">
      <br>
      <h6>Description</h6>
      @if (task) {
      <textarea pInputTextarea name="description" required class="form-control" [(ngModel)]="task.description"
        [rows]="8" style="width: 100%;"></textarea>
      }
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12 columnPadding">
      @if (taskForm.invalid && taskForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
  </div>
  <div class="row-container" style="flex-direction: row-reverse;">
    <p-button type="submit" severity="success" [disabled]="saving" (click)="save(taskForm)" label="Save">
    </p-button>
    <p-button type="button" severity="warn" (click)="cancel()" label="Cancel">
    </p-button>
    <p-button type="button" severity="danger" (click)="delete()" [disabled]="disableDelete" label="Delete">
    </p-button>
  </div>
</form>